/* Verano Design : sélecteur pays · devise · langue de la barre noire (sections/announcement-bar.liquid).
   Ordinateur : dialog.show() sous le bouton, fermeture au clic dehors. Mobile (< 1024 px) : showModal(),
   panneau qui monte du bas avec fond assombri. Recherche sans accents sur data-recherche des lignes.
   « Enregistrer » soumet le formulaire de localisation Shopify sans script. */
if (!customElements.get('selecteur-pays')) {
  const sansAccents = (texte) => texte.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

  class SelecteurPays extends HTMLElement {
    connectedCallback() {
      this.panneau = this.querySelector('dialog');
      if (!this.panneau) return;
      this.boutons = this.querySelectorAll('[aria-controls="' + this.panneau.id + '"]');
      this.recherche = this.panneau.querySelector('input[data-recherche]');
      this.lignes = Array.from(this.panneau.querySelectorAll('.selecteur-pays__ligne'));
      this.groupes = Array.from(this.panneau.querySelectorAll('[data-groupe]'));
      this.vide = this.panneau.querySelector('[data-vide]');

      this.lignes.forEach((ligne) => { ligne.dataset.cle = sansAccents(ligne.dataset.recherche || ''); });

      this.boutons.forEach((bouton) => bouton.addEventListener('click', (event) => {
        event.stopPropagation();
        this.panneau.open ? this.fermer() : this.ouvrir(bouton);
      }));
      this.panneau.querySelectorAll('[data-fermer]').forEach((bouton) => bouton.addEventListener('click', () => this.fermer()));
      this.panneau.addEventListener('close', () => this.apresFermeture());
      this.panneau.addEventListener('cancel', (event) => { event.preventDefault(); this.fermer(); });
      // Clic sur le fond assombri (mobile) : la cible est le dialog lui-même.
      this.panneau.addEventListener('click', (event) => { if (event.target === this.panneau) this.fermer(); });
      this.recherche?.addEventListener('input', () => this.filtrer());

      this.clicDehors = (event) => { if (this.panneau.open && !this.contains(event.target)) this.fermer(); };
      this.echap = (event) => { if (event.key === 'Escape' && this.panneau.open) this.fermer(); };
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.clicDehors);
      document.removeEventListener('keydown', this.echap);
    }

    ouvrir(bouton) {
      this.declencheur = bouton;
      if (window.matchMedia('(min-width: 1024px)').matches) {
        this.panneau.show();
        document.addEventListener('click', this.clicDehors);
        document.addEventListener('keydown', this.echap);
      } else {
        // showModal() donne le focus au bouton Fermer alors que le panneau est encore sous l'écran
        // (début de l'animation) : le navigateur fait défiler la page pour le montrer. On la remet en place.
        const hauteur = window.scrollY;
        this.panneau.showModal();
        if (window.scrollY !== hauteur) window.scrollTo({ top: hauteur, behavior: 'instant' });
        // Le focus va au panneau lui-même, pas au bouton Fermer : sinon iOS l'entoure d'un anneau bleu.
        this.panneau.focus({ preventScroll: true });
        document.documentElement.style.overflow = 'hidden';
      }
      this.boutons.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      // Centre le pays coché en ne faisant défiler que la liste : scrollIntoView ferait aussi défiler
      // la page pendant la montée du panneau, et Safari iOS décale alors le panneau hors de l'écran.
      const liste = this.panneau.querySelector('.selecteur-pays__liste');
      const ligne = this.panneau.querySelector('.selecteur-pays__radio:checked')?.closest('.selecteur-pays__ligne');
      if (liste && ligne) {
        liste.scrollTop = ligne.offsetTop - liste.offsetTop - (liste.clientHeight - ligne.offsetHeight) / 2;
      }
      if (window.matchMedia('(min-width: 1024px)').matches) this.recherche?.focus({ preventScroll: true });
    }

    fermer() {
      if (this.panneau.open) this.panneau.close();
      else this.apresFermeture();
    }

    apresFermeture() {
      document.removeEventListener('click', this.clicDehors);
      document.removeEventListener('keydown', this.echap);
      document.documentElement.style.removeProperty('overflow');
      this.boutons.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      if (this.recherche && this.recherche.value) {
        this.recherche.value = '';
        this.filtrer();
      }
      if (this.declencheur && this.declencheur.offsetParent) this.declencheur.focus({ preventScroll: true });
    }

    filtrer() {
      const saisie = sansAccents(this.recherche.value);
      let total = 0;
      this.lignes.forEach((ligne) => { ligne.hidden = saisie !== '' && !ligne.dataset.cle.includes(saisie); });
      this.groupes.forEach((groupe) => {
        const visibles = groupe.querySelectorAll('.selecteur-pays__ligne:not([hidden])').length;
        groupe.hidden = visibles === 0;
        const compte = groupe.querySelector('[data-compte]');
        if (compte) compte.textContent = visibles;
        total += visibles;
      });
      if (this.vide) this.vide.hidden = total !== 0;
    }
  }

  customElements.define('selecteur-pays', SelecteurPays);

  // Ligne du menu mobile (snippets/header-drawer.liquid) : ouvre le même panneau.
  document.addEventListener('click', (event) => {
    const bouton = event.target.closest('[data-selecteur-pays-ouvrir]');
    if (!bouton) return;
    event.preventDefault();
    event.stopPropagation();
    document.querySelector('selecteur-pays')?.ouvrir(bouton);
  });
}
